import { ck, URLS } from "fire-wind-water";
import URL from "@/assets/conf/setting.json";
import { createField, updateDirty } from "../../stempcore/src/core/sfield";
import { resetURL, setUploadURL, setURL } from "../../stempcore/src/sbase";

// TODO: 本项目需要保留那些值
ck.json = true;
const tenantId = URLS.getURL("tenantId");
const weChatId = URLS.getURL("weChatId");
const accKey = URLS.getURL("accKey");
const sourceKey = URLS.getURL("sourceKey");
const instanceId = URLS.getURL("instanceId");
const webinarId = URLS.getURL("webinarId");
const customFormId = URLS.getURL("customFormId");
const isSetting = URLS.getURL("isSetting");
const tc = URLS.getURL("tc");
const markCode = URLS.getURL("markCode");
const linkId = URLS.getURL("linkId");
const fileUrl = URL.sbaseUrl;
resetURL(URL);
setUploadURL(URL.template.api.ungateway.contentUrl);
setURL(URL.template.api.gateway.general + "/");
export const updateSearchParam = function(key, value, originalUrl) {
var rurl = originalUrl || window.location.href;
var urls = rurl.match(/([^?#]+)?(\?[^#]+)?(#[^?]+)?(\?[\w\W]+)?/);
if (!urls) {
    return rurl;
}
var url = urls[1] || '';
var searchURL = urls[2] || '';
var routerURL = urls[3] || '';
var routerParam = urls[4] || '';
if (searchURL) {
    var searchs = searchURL.replace(/^\?/, '').split('&');
    var newSearch = [];
    var newSearchJson = {};
    for (var i = 0; i < searchs.length; i++) {
        var items = searchs[i];
        var item = items.split('=');
        newSearchJson[item[0]] = true;
        if (item[0] === key) {
            newSearch.push(item[0] + '=' + value);
        } else {
            newSearch.push(item[0] + '=' + item[1]);
        }
    }
    if (!newSearchJson[key]) {
        newSearch.push(key + '=' + value);
    }
        searchURL = '?' + newSearch.join('&');
    } else {
        searchURL = '?' + key + '=' + value;
    }
    var rl = url + searchURL + routerURL + routerParam;
    return rl;
}
  
export {
  tenantId,
  weChatId,
  accKey,
  sourceKey,
  tc,
  markCode,
  instanceId,
  webinarId,
  customFormId,
  isSetting,
  fileUrl,
  linkId,
  createField,
  updateDirty
};
